import { useEffect, useRef } from 'react';

declare global {
  interface Window {
    jwplayer: any;
  }
}

const VideoPlayer = ({ mediaId }: { mediaId: string }) => {
  const playerRef = useRef(null);
  const playlistUrl = `//cdn.jwplayer.com/v2/sites/wZk0v347/media/${mediaId}/playback.json`;

  useEffect(() => {
    if (playerRef.current && typeof window !== 'undefined' && window.jwplayer) {
      window.jwplayer(playerRef.current).setup({
        playlist: playlistUrl,
        aspectratio: '16:9',
        autostart: true,
        repeat: true,
      });
    }
  }, [mediaId]);

  return (
    <div style={{ width: '75%' }}>
      <div ref={playerRef}></div>
    </div>
  );
};

export default VideoPlayer;
